import ButtonIcon from "@visa/vds/button-icon";
import Icon from "@visa/vds/icon";
import Tooltip from "rc-tooltip";
import React from "react";

const PostFormNoticeTooltip = () => {
  const text = `Links in a NOTICE will default display in the "current window". 
    To have a link be displayed in a "new window", click on the "<>" icon and refer to the example below:
    <a href="http://www.emvco.com" target="_blank">EMVCo. website</a>. 
    For Terms of Use, please refer to the example:<a href="VisaSecureServices/TermsOfUse" target="_blank">Terms of Use</a>.`;
  return (
    <>
      <Tooltip
        trigger="['click']"
        placement="right"
        overlay={<span>{text}</span>}
        overlayInnerStyle={{ maxWidth: "19rem" }}
      >
        <ButtonIcon
          ariaLabel="store-open"
          className="btn-searchField-tooltip"
          iconType="light-tiny"
        >
          <Icon name="info" resolution="tiny" />
        </ButtonIcon>
      </Tooltip>
    </>
  );
};
export default PostFormNoticeTooltip;
